import React from "react";
import styles from "./card.module.css";

const Card = ({
  header,
  paragraph,
  smallCardItem,
  largeCardItem,
  responsiveImage,
  responsiveImageChecked,
}) => {
  return (
    <div
      className={`${largeCardItem ? styles.largeCard : styles.card} ${
        smallCardItem ? styles.smallCard : ""
      }`}
    >
      {responsiveImageChecked ? (
        <img src={responsiveImage} alt="Icon" className={styles.iconSmall} />
      ) : (
        ""
      )}

      <h2 className={styles.header}>{header}</h2>
      <p className={styles.paragraph}>{paragraph}</p>
    </div>
  );
};

export default Card;
